import { useForm } from "react-hook-form";
import React, { useContext, useRef, useState } from "react";
import * as Helper from "../../form/form_inscription_helper";
import * as Pattern from "../../form/form_pattern_helper";
import CustomFieldText from "../../form/CustomFieldText";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { UserContext } from "../../context/UserContext";

const Connexion = () => {

  const { t } = useTranslation();

  //form validation handle
  const { register, handleSubmit, formState: { errors } } = useForm()
  const submitRef = useRef(null)

  const [globalError, setGlobalError] = useState("")

  const { login } = useContext(UserContext)
  const navigate = useNavigate()

  const handleFormSubmit = (data) => {
    submitRef.current.setAttribute("disabled", "disabled");

    let formData = new FormData();
    formData.append('form', JSON.stringify(data));
    formData.append("action", "login");

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(json => {
        if (json.success === true) {
          login(json.data.jwt)
          navigate("/mes-cartes")
        } else {

          switch (json.message) {

            case "#unknow_account":
              setGlobalError(t("connexion_compte_inconnu"))
              break;

            default:
              alert(json.message);
          }
          submitRef.current.removeAttribute("disabled");
        }

      });

  }

  return (
    <div className={"strate footer header"} id={"connexionStrate"}>
      <div>
        <form onSubmit={handleSubmit(handleFormSubmit)}>

          <CustomFieldText name="login" placeholder={t("connexion_placeholder_adresse_email")} register={register('login', {
            required: Helper.EmptyErrorMessages.mail,
            pattern: { value: Pattern.emailPattern, message: Helper.InvalidErrorMessages.mail },
          })} error={errors.login && errors.login.message} />

          <CustomFieldText name="password" placeholder={t("connexion_placeholder_mot_de_passe")} type="password" register={register('password', {
            required: Helper.EmptyErrorMessages.password
          })} error={errors.password && errors.password.message} />

          <div className={"link_wrapper"}>
            <Link to={"/mot-de-passe-oublie"}>{t("connexion_mot_de_passe_oublie")}</Link>
          </div>

          <div className={"cta_wrapper"}>
            <div className={"error"}>{globalError}</div>
            <button className={"cta gold"} type="submit" ref={submitRef} dangerouslySetInnerHTML={{ __html: t("connexion_se_connecter") }} />
          </div>
        </form>

        <div className={"link_wrapper"}>
          {t("connexion_pas_encore_inscrit")} <Link to={"/inscription"}>{t("connexion_creer_compte")}</Link>
        </div>

      </div>
    </div>
  )
}

export default Connexion
